const handleError = (error, comment = 'Request could not be processed at this time. Please try again later.') => {
  // response status code falls out of the range of 2xx
  if (error.response) {
    // Check for message in response.data
    if (error.response.data && error.response.data.message) {
      return error.response.data.message;
    }
    // Fallback to comment if no message found
    return comment;
  }
  // the request was made but no response was received
  if (error.request) {
    return 'Network Error';
  }
  // the code has an error
  return comment;
};

export default handleError;
